/*
 * @Author:SMG
 * @Date: 2016-5-11
 * @LastEditTime: 2021-04-06 13:45:17
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\manageConfig\groupUserManageMent\group\gGroupManageMent.js
 * @Description: 子用户管理
 */
'use strict';

angular.module('gGroupManageMentModule', ['groupManageMentServiceModule'])
    . controller('gGroupManageMentController', ['$scope', '$q', '$state', '$stateParams', '$location', 'treeService', 'trsHttpService', 'modalDialog', 'trsspliceString', 'trsGroupTreeLocationService', 'groupManageMentService', 'groupUserRightsService', 'localStorageService',
        function($scope, $q, $state, $stateParams, $location, treeService, trsHttpService, modalDialog, trsspliceString, trsGroupTreeLocationService, groupManageMentService, groupUserRightsService, localStorageService) {
            initStatus();
            initData();

            /**
             * [initStatus description] 初始化状态
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.status = {
                    testStatus: $location.path().split('/')[3],
                    dragStartIndex: '',
                    groupStatus: [{
                        name: '全部组织',
                        value: 0,
                    }, {
                        name: '隐藏组织',
                        value: 2
                    }],
                    btnRights: {},
                };
                // $scope.selectedNode = [];
                $scope.data = {
                    selectedArray: [], // 已选
                    keywords: '',
                    groups: [],
                    parentGroupid: $stateParams.groupid,
                    copyCurrPage: 1,
                    treeData: [],
                    currGroup: {},
                    totalCounts: 0,
                    initStatus: $stateParams.status, // 初始化状态：30
                    // userGroupId: localStorageService.get("mlfCachedUser").GroupId,
                    rootGroupoID: $stateParams.groupid,
                };
                $scope.page = {
                    'CURRPAGE': 1,
                    'PAGESIZE': 20,
                    'ITEMCOUNT': 0,
                };
            }

            /**
             * [initData description] 初始化数据
             * @return  {[type]}  [return description]
             */
            function initData() {
                groupUserRightsService.initBtnRights('config.group', $stateParams.groupid).then(function(data) {
                    $scope.status.btnRights[$scope.data.rootGroupoID] = data;
                });
                treeService.queryGroupTreeWithSecondRight().then(function(data) {
                    $scope.data.treeData = data;
                    initDropDown();
                    requestData().then(function() {
                        $scope.data.totalCounts = angular.copy($scope.page.ITEMCOUNT);
                    });
                    getGroupDetail();
                });

            }

            /**
             * [initBtnRights description]获得组织权限
             * @param  {[obj]} item [description]组织信息
             * @return {[null]}      [description]
             */
            $scope.initBtnRights = function(item) {
                groupUserRightsService.initBtnRights('config.group', item.GROUPID).then(function(data) {
                    $scope.status.btnRights[item.GROUPID] = data;
                });
            };

            /**
             * [initDropDown description]初始化下拉框
             * @return {[type]} [description]
             */
            function initDropDown() {
                $scope.status.selectedGroupStatus = angular.copy($scope.status.groupStatus[0]);
            }

            /**
             * [getGroupDetail description] 根据groupid获取组织信息
             * @return  {[type]}  [return description]
             */
            function getGroupDetail() {
                var params = {
                    'serviceid': 'mlf_groupmanagement',
                    'methodname': 'getGroupDetail',
                    'GroupId': $stateParams.groupid
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $scope.data.currGroup = data;
                });
            }
            // 下一页
            $scope.pageChanged = function() {
                $scope.data.copyCurrPage = $scope.page.CURRPAGE;
                requestData();
            };

            // 跳转指定页面
            $scope.jumpToPage = function() {
                if ($scope.data.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.data.copyCurrPage = $scope.page.PAGECOUNT;
                }
                $scope.page.CURRPAGE = $scope.data.copyCurrPage;
                requestData();
            };

            /**
             * [selectPageNum description]单页选择分页数
             * @return {[type]} [description]
             */
            $scope.selectPageNum = function() {
                $scope.data.copyCurrPage = 1;
                requestData();
            };

            /**
             * [requestData description] 根据当前组织获取子组织列表信息
             * @return  {[type]}  [return description]
             */
            function requestData() {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_groupmanagement',
                    methodname: 'getChildrenGroup',
                    CurrPage: $scope.page.CURRPAGE,
                    pagesize: $scope.page.PAGESIZE,
                    GroupId: $scope.data.parentGroupid ? $scope.data.parentGroupid : $scope.data.treeData.GROUPID,
                    IsSearch: $scope.data.keywords != '',
                    SearchName: $scope.data.keywords,
                    Status: $scope.status.selectedGroupStatus.value,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $scope.groups = data.DATA || data;
                    !!data.PAGER ? $scope.page = data.PAGER : $scope.page.ITEMCOUNT = '0';
                    $scope.page.CURRPAGE = Math.abs($scope.page.CURRPAGE); // 应对后端返回分页存在问题的情况
                    $scope.data.selectedArray = [];
                    timeStamp();
                    defer.resolve();
                });
                return defer.promise;
            }

            /**
             * [timeStamp description]  将日期字符串转换为时间戳
             * @return  {[type]}  [return description]
             */
            function timeStamp() {
                angular.forEach($scope.groups, function(data, index) {
                    if (data.CRTIME != '') {
                        data.CRTIME = new Date(Date.parse(data.CRTIME.replace(/-/g, '/'))).getTime();
                    }
                });
            }

            /**
             * [queryDropDown description]根据下拉框查询
             * @return {[type]} [description]null
             */
            $scope.queryDropDown = function() {
                requestData();
            };

            /**
             * [filterGroup description]组织过滤器
             * @param  {[obj]} elm [description]每个组织元素
             * @return {[boolean]}     [description]
             */
            $scope.filterGroup = function(elm) {
                if (angular.isDefined(elm.STATUS)) {
                    return elm.STATUS == 2;
                }
            };

            /**
             * [hiddenGroup description] 隐藏组织
             * @param   {[type]}  item  [item description]
             * @return  {[type]}        [return description]
             */
            $scope.hiddenGroup = function(item) {
                if (item.STATUS === '2') {$scope.restoreGroup(item);} else {hiddenGroup(item);}
            };

            /**
             * [hiddenGroup description] 隐藏组织
             * @param   {[obj]}  item   [item description] 组织信息
             * @return  {[type]}        [return description]
             */
            function hiddenGroup(item) {
                modalDialog.confirmModal('隐藏组织', '确认将所选组织隐藏', function() {
                    var params = {
                        serviceid: 'mlf_groupmanagement',
                        methodname: 'hideawayGroup',
                        ParentId: item.PARENTID,
                        GroupIds: item.GROUPID,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        modalDialog.alertType('隐藏组织成功', '', 'success', false, function() {
                            requestData();
                        });
                    });
                });
            }

            /**
             * [restoreGroup description]还原组织
             * @param  {[obj]} item [description]组织信息
             * @return {[type]}      [description]
             */
            $scope.restoreGroup = function(item) {
                modalDialog.confirmModal('还原组织', '确认将所选组织还原', function() {
                    var params = {
                        serviceid: 'mlf_groupmanagement',
                        methodname: 'originalGroup',
                        ParentId: item.PARENTID,
                        GroupIds: item.GROUPID,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        modalDialog.alertType('还原组织成功', '', 'success', false, function() {
                            requestData();
                        });
                    });
                });
            };

            /**
             * [selectAll description] 全选
             * @return  {[type]}  [return description]
             */
            $scope.selectAll = function() {
                $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.groupDatas.length ? [] : [].concat($scope.groupDatas);
                cancelBatchOperate();
            };

            /**
             * [selectDoc description] 单选
             * @param   {[type]}  item  [item description]
             * @return  {[type]}        [return description]
             */
            $scope.selectDoc = function(item) {
                if ($scope.data.selectedArray.indexOf(item) < 0) {
                    $scope.data.selectedArray.push(item);
                } else {
                    $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
                }
                cancelBatchOperate();
            };
            
            /**
             * [cancelBatchOperate description] 取消批量操作的样式
             * @return  {[type]}  [return description]
             */
            function cancelBatchOperate() {
                if ($scope.data.selectedArray.length === 0) {
                    $scope.status.batchOperateBtn = {
                        'hoverStatus': '',
                        'clickStatus': ''
                    };
                }
            }

            /**
             * [newGroup description] 新建组织
             * @return  {[type]}  [return description]
             */
            $scope.newGroup = function() {
                groupManageMentService.createOrEditGroup('', $scope.data.parentGroupid).then(function(data) {
                    $state.go($state.current.name, $stateParams, { reload: true });
                }, function(data) {
                // 失败
                });
            };

            /**
             * [editGroupDetail description] 修改组织
             * @param   {[type]}  item  [item description]
             * @return  {[type]}        [return description]
             */
            $scope.editGroupDetail = function(item) {
                groupManageMentService.createOrEditGroup(item, $scope.data.parentGroupid).then(function(data) {
                    $state.go($state.current.name, $stateParams, { reload: true });
                }, function(data) {
                // 失败
                });
            };

            /**
             * [deleteGroup description] 删除组织
             * @param   {[type]}  item  [item description]
             * @return  {[type]}        [return description]
             */
            $scope.deleteGroup = function(item) {
                modalDialog.confirmModal('删除组织', '确认删除[' + item.GNAME + ']', function() {
                    var params = {
                        serviceid: 'mlf_groupmanagement',
                        methodname: 'deleteGroup',
                        GroupIds: item.GROUPID,
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        modalDialog.alertType('删除组织成功', '', 'success', false, function() {
                            $state.go($state.current.name, $stateParams, { reload: true });
                        });
                    });
                });
            };

            /**
             * [moveGroup description] 移动组织
             * @param   {[type]}  item  [item description]
             * @return  {[type]}        [return description]
             */
            $scope.moveGroup = function(item) {
                var itemC = {
                    fromGroupId: item.GROUPID,
                    parentGroupId: item.PARENTID
                };
                groupManageMentService.userMngGroupMngMoveGroup('移动组织', itemC, function(data) {
                    $state.go($state.current.name, $stateParams, { reload: true });
                });
            };

            /**
             * [showGroupDetail description] 查看组织信息
             * @param   {[type]}  item  [item description]
             * @return  {[type]}        [return description]
             */
            $scope.showGroupDetail = function(item) {
                if ($scope.status.btnRights[item.GROUPID].watch) {
                    groupManageMentService.showGroupDetail('组织详细信息', item.GROUPID, function(data) {});
                }
            };

            /**
             * [sortGroup description] 列表排序（设置位置）
             * @param   {[type]}  item   [item description]
             * @param   {[type]}  index  [index description]
             * @return  {[type]}         [return description]
             */
            $scope.sortGroup = function(item, index) {
                index = ++index;
                groupManageMentService.sortGroups('组织---调整顺序', item.GROUPID, $scope.data.parentGroupid, $scope.data.totalCounts, item.GNAME, function(data) {
                    modalDialog.alertType('', '调整顺序成功', 'success', false, function() {});
                    $scope.loadingPromise = requestData();
                    $scope.$root.$broadcast('gGroupOrding', true); // 通知左侧导航也更新数据
                }, index);
            };

            /**
             * [gotoGroupUsersList description] 跳转到当前组织对应的用户列表模块
             * @return  {[type]}  [return description]
             */
            $scope.gotoGroupUsersList = function() {
                $state.go('manageconfig.groupmanage.user', { groupid: $scope.data.parentGroupid, status: $scope.data.initStatus }, { reload: 'manageconfig.groupmanage.user' });
            };

            /**
             * [gotoUsersList description] 跳转到当前组织列表子组织对应的用户列表模块
             * @param   {[type]}  group  [group description]
             * @return  {[type]}         [return description]
             */
            $scope.gotoUsersList = function(group) {
                $state.go('manageconfig.groupmanage.user', { groupid: group.GROUPID, status: $scope.data.initStatus }, { reload: true });
            };

            /**
             * [groupNameSearch description] 检索:根据用户真实姓名模糊查询用户列表(全文检索)]
             * @param   {[type]}  ev  [ev description]
             * @return  {[type]}      [return description]
             */
            $scope.groupNameSearch = function(ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                // queryGroupByGName();
                    requestData();
                }
            };

            /**
             * [dragoverCallback description] 允许拖拽
             * @param   {[type]}  event     [event description]
             * @param   {[type]}  index     [index description]
             * @param   {[type]}  external  [external description]
             * @param   {[type]}  type      [type description]
             * @return  {[type]}            [return description]
             */
            $scope.dragoverCallback = function(event, index, external, type) {
                return true;
            };

            /**
             * [dragStart description]拖拽开始
             * @param   {[type]}  event  [event description]
             * @param   {[type]}  item   [item description]
             * @param   {[type]}  index  [index description]
             * @return  {[type]}         [return description]
             */
            $scope.dragStart = function(event, item, index) {
                $scope.status.dragStartIndex = index;
            };

            /**
             * [dropCallback description] 拖拽结束
             * @param   {[type]}  event        [event description]
             * @param   {[type]}  index        [index description]
             * @param   {[type]}  item         [item description]
             * @param   {[type]}  external     [external description]
             * @param   {[type]}  type         [type description]
             * @param   {[type]}  allowedType  [allowedType description]
             * @return  {[type]}               [return description]
             */
            $scope.dropCallback = function(event, index, item, external, type, allowedType) {
                if ($scope.status.dragStartIndex == index) {
                    return;
                }
                var params = {
                    serviceid: 'mlf_groupmanagement',
                    methodname: 'sortPositionGroup',
                    FromGroupId: $scope.groups[$scope.status.dragStartIndex].GROUPID,
                    ToGroupId: $scope.status.dragStartIndex > index ? $scope.groups[index].GROUPID : $scope.groups[index - 1].GROUPID,
                    Position: $scope.status.dragStartIndex > index ? 1 : 0,
                    ParentId: $scope.data.parentGroupid,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function() {
                    requestData();
                    $scope.$root.$broadcast('gGroupOrding', true); // 通知左侧导航也更新数据
                });
            };
        }
    ]);
